import styled from '@emotion/styled';

/**
 * Booking / storefront actions: `buttonVariant` matches GradientButton `variant`.
 * Uses landing-page CSS variables when present (website builder theme); otherwise fallbacks.
 */
const PrimaryButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'buttonVariant'
})`
  display: flex;
  padding: 0.75rem 1.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 700;
  font-family: 'Poppins', system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  letter-spacing: 0.05em;
  text-align: center;
  cursor: pointer;
  vertical-align: middle;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  user-select: none;
  gap: 0.75rem;
  transition: all 0.6s ease;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    box-shadow: none;
  }

  ${({ buttonVariant = 'success' }) =>
    buttonVariant === 'primary'
      ? `
    border: 2px solid var(--page-accent, #488aec);
    background: #ffffff;
    color: var(--page-accent, #488aec);
    box-shadow: none;

    &:hover:not(:disabled) {
      background: var(--page-accent-soft, rgba(72, 138, 236, 0.08));
      box-shadow: none;
    }

    &:focus,
    &:active:not(:disabled) {
      opacity: 0.9;
      box-shadow: none;
    }
  `
      : `
    border: none;
    background: var(--header-cta-bg, var(--page-accent-strong, #488aec));
    color: var(--header-cta-fg, #ffffff);
    box-shadow:
      0 4px 6px -1px rgba(var(--page-accent-rgb, 72, 138, 236), 0.31),
      0 2px 4px -1px rgba(var(--page-accent-rgb, 72, 138, 236), 0.17);

    &:hover:not(:disabled) {
      filter: brightness(1.06);
      box-shadow:
        0 10px 15px -3px rgba(var(--page-accent-rgb, 72, 138, 236), 0.35),
        0 4px 6px -2px rgba(var(--page-accent-rgb, 72, 138, 236), 0.17);
    }

    &:focus,
    &:active:not(:disabled) {
      opacity: 0.9;
      box-shadow: none;
    }
  `}
`;

export default PrimaryButton;
